export type UserDTO = {
  id: string;
  email: string | null;
  first_name: string | null;
  last_name: string | null;
  external_identifier?: string | null;
  avatar?: string | null;
};

export enum UserRole {
  ADMINISTRATOR = 'Administrator',
  AGENCY = 'Agentur',
  HIRING_ORG = 'Hiring Org',
  PUBLIC = 'Öffentlich',
}
